import React, { useState } from "react";

import Table from "components/Table";
import Filter from "@Components/Filter";
import { useHistory } from "react-router-dom";

let model = [
  { id: "name", label: "Role", type: "string" },
  {
    id: "is_active",
    label: "Active",
    type: "boolean",
    yesValue: "Active",
    noValue: "Inactive",
  },
  {
    id: "mobile_access",
    label: "Mobile Access",
    type: "boolean",
    yesValue: "Yes",
    noValue: "No",
  },
  {
    id: "role_mapping_name",
    label: "Role Mapping",
    type: "string"
    
  },
];

const isRoleDelete = true;
const pageNumberDropdown = true;

const filterFields = [
  {
    type: "input",
    label: "Role",
    name: "role",
  },
  {
    type: "reactselect",
    name: "is_active",
    label: "Is Active",
    outerOptions: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
  {
    type: "reactselect",
    name: "mobile_access",
    label: "Mobile Access",
    outerOptions: [
      { id: "0", name: "No" },
      { id: "1", name: "Yes" },
    ],
  },
];

const filterInitialValues = {
  role: "",
  is_active: "",
};

const Role = () => {
  const [filterValues, setFilterValues] = useState({});

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
  const history = useHistory();

  const actions = [
  //      {
  //   type: "view",
  //   title: "View",
  //   icon: <VisibilityIcon />,
  //   color: "secondary",
  //   onClick: (id) => history.push(`${history.location.pathname}/view-details/${id}`),
  // },
    "edit", "delete"];
  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }

  return (
    <>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
        onClear={clearFilter}

      />
      <Table
        proxyURL="role/"
        model={model}
        actions={actions}
        excelExport
        pageNumberDropdown={pageNumberDropdown}
        noFilter
        filterValues={filterValues}
        isRoleDelete={isRoleDelete}
      />
    </>
  );
};
export default Role;
